import Work1 from "../../assets/work1.png";
import Work2 from "../../assets/work2.png";
import Work3 from "../../assets/work3.jpeg";
import Work4 from "../../assets/work4.png";
import Work5 from "../../assets/work5.png";
import Work6 from "../../assets/work6.png";
import Work7 from "../../assets/work7.png";
import Work8 from "../../assets/work8.png";
import Work9 from "../../assets/work9.png";
import Work10 from "../../assets/work10.png";
import Work12 from "../../assets/Work12.png"
import Work13 from "../../assets/work14.jpg"
import Work14 from "../../assets/work13.jpg"
import Work15 from "../../assets/wave.png"
import Work16 from "../../assets/pop.jpg"
import Work17 from "../../assets/Work17.jpeg"




export const projectsData = [
  {
    id: 0,
    image: Work15,
    title: "Wave(A music App)",
    category: "app",
    url: "https://github.com/Asim-Sidd02/WaveMusic",
  },

  {
    id: 1,
    image: Work12,
    title: "RiskPredicitionSystem",
    category: "IoT/ML",
    url: "https://github.com/Asim-Sidd02/RiskPredectionSystem",
  },
  {
    id: 2,
    image: Work16,
    title: "Popcorn Pal(A movie app UI)",
    category: "app",
    url: "https://github.com/Asim-Sidd02/PopcornPal",
  },
  {
    id: 3,
    image: Work14,
    title: "Weather App",
    category: "app",
    url: "https://github.com/Asim-Sidd02/Weather-App",
  },
   {
    id: 4,
    image: Work17,
    title: "TaskMate",
    category: "app",
    url: "https://github.com/Asim-Sidd02/TaskMate",
  },
 
   
  {
    id: 5,
    image: Work13,
    title: "Spendster(Expense Tracking App)",
    category: "app",
    url: "https://github.com/Asim-Sidd02/Spendster",
  },
      {
        id: 6,
        image: Work3,
        title: "Magic Mirror",
        category: "IoT/ML",
        url: "https://github.com/Asim-Sidd02/MagicMirror/tree/main/MagicMirror",
      },
      {
        id: 7,
        image: Work4,
        title: "Mental Health Chatbot",
        category: "web",
        url: "https://github.com/Asim-Sidd02/HackForHealth",
      },
      {
        id: 8,
        image: Work5,
        title: "Plan And Scheduling App",
        category: "app",
        url: "https://github.com/Asim-Sidd02/Plan-Scheduling-App",
      },
     
      {
        id: 9,
        image: Work7,
        title: "Task Management System",
        category: "web",
        url: "https://github.com/Asim-Sidd02/TaskManagementSystem",
      },
      {
        id: 10,
        image: Work9,
        title: "Customizable Chatbot",
        category: "IoT/ML",
        url: "https://github.com/Asim-Sidd02/KgrVirtualAssistant",
      },
      {
        id: 11,
        image: Work8,
        title: "Tic Tac Toe",
        category: "app",
        url: "https://github.com/Asim-Sidd02/TicTacToe--Using-Flutter",
      },
      {
        id: 12,
        image: Work1,
        title: "Web Repository Viewer",
        category: "web",
        url: "https://github.com/Asim-Sidd02/GitHub-Repository-Finder-By-Username",
      },
     
     
      {
        id: 13,
        image: Work6,
        title: "Speech To Text Convertor",
        category: "app",
        url: "https://github.com/Asim-Sidd02/SpeechToText",
      },
      {
        id: 14,
        image: Work2,
        title: "Metrial Management App",
        category: "app",
        url: "https://github.com/C0debl00ded/Material_Management_App",
      },
      {
        id: 15,
        image: Work10,
        title: "Web Chat App",
        category: "web",
        url: "https://github.com/Asim-Sidd02/WebChatApp",
      },
     
   

]

export const projectsNav = [
    {
        name: 'all',
    },
    {
        name: 'web',
    },
    {
        name: 'app',
    },
    {
        name: 'IoT/ML',
    },
];
